import Cta from "@components/Cta/Cta";
import { GeneralLink } from "@customTypes/generalLink";
import styles from "./C271_ThinkCtaContainer.module.scss";

export interface CtaItem {
  fields: {
    description?: string;
    cta: GeneralLink;
    isSecondaryCta: boolean;
  };
}

interface Cta {
  description?: string;
  cta: GeneralLink;
  isSecondaryCta: boolean;
}

export interface C271ThinkCtaItemProps {
  content?: Cta;
  isBlue: boolean;
  ctaContent?: CtaItem;
}

const C271_ThinkCtaItem = (props: C271ThinkCtaItemProps) => {
  const { content, ctaContent, isBlue } = props;

  const ctaData = content || ctaContent?.fields;
  if (!ctaData?.cta?.fields) return null;

  return (
    <div>
      <Cta
        customClass={styles["button"]}
        light={isBlue}
        type={ctaData.isSecondaryCta ? "secondary" : "primary"}
        openInNewTab={false}
        {...ctaData.cta.fields}
      />
    </div>
  );
};

export default C271_ThinkCtaItem;
